"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileLoadedFromServer = exports.FILE_LOADED_FROM_SERVER = void 0;
exports.FILE_LOADED_FROM_SERVER = "serverFile.file_loaded_from_server";
function fileLoadedFromServer(file) {
    return {
        type: exports.FILE_LOADED_FROM_SERVER,
        file,
    };
}
exports.fileLoadedFromServer = fileLoadedFromServer;
// TODO - This should be updatable when we reload from the server.
function serverFileReducer(state, action) {
    if (action.type === exports.FILE_LOADED_FROM_SERVER) {
        return action.file;
    }
    return state;
}
exports.default = serverFileReducer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VydmVyRmlsZVJlZHVjZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9wcm9qZWN0L3NlcnZlckZpbGVSZWR1Y2VyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFHYSxRQUFBLHVCQUF1QixHQUFHLG9DQUFvQyxDQUFDO0FBRTVFLFNBQWdCLG9CQUFvQixDQUFDLElBQStCO0lBQ2xFLE9BQU87UUFDTCxJQUFJLEVBQUUsK0JBQXVCO1FBQzdCLElBQUk7S0FDTCxDQUFDO0FBQ0osQ0FBQztBQUxELG9EQUtDO0FBRUQsa0VBQWtFO0FBQ2xFLFNBQXdCLGlCQUFpQixDQUN2QyxLQUFnQyxFQUNoQyxNQUFpQjtJQUVqQixJQUFJLE1BQU0sQ0FBQyxJQUFJLEtBQUssK0JBQXVCLEVBQUU7UUFDM0MsT0FBTyxNQUFNLENBQUMsSUFBSSxDQUFDO0tBQ3BCO0lBQ0QsT0FBTyxLQUFLLENBQUM7QUFDZixDQUFDO0FBUkQsb0NBUUMifQ==